import {GetInteractionHandlersOptions} from '../index';
import openPopup, {isPopupFeature} from '../openPopup';
import convertLngLat from '../../../mapbox/convertLngLat';

export default {

    getCursor: (interaction: NormalMapInteraction) => {
        if (interaction.subtype === 'hovering') {
            return 'pointer';
        } else {
            return 'default';
        }
    },

    onMouseDown: () => {},

    onMouseUp: () => {},

    onMouseMove: (event: mapboxgl.MapTouchEvent | mapboxgl.MapMouseEvent, {
        onInteractionChange,
        mapboxStyle,
    }: GetInteractionHandlersOptions<NormalMapInteraction>) => {
        const bbox: [mapboxgl.PointLike, mapboxgl.PointLike] = [
            [event.point.x + 2, event.point.y + 2],
            [event.point.x - 2, event.point.y - 2],
        ];

        const feature = event.target.queryRenderedFeatures(bbox).filter(f =>
            isPopupFeature(f, mapboxStyle)
        )[0];

        if (feature) {
            onInteractionChange({type: 'normal', subtype: 'hovering', feature});
        } else {
            onInteractionChange({type: 'normal', subtype: 'normal'});
        }
    },

    onMouseOut: () => {},

    onClick: (event: mapboxgl.MapTouchEvent | mapboxgl.MapMouseEvent, {
        interaction,
        onPopupChange,
        popup,
        waypointDispatcher,
        trackDispatcher,
        areaDispatcher,
        onSearchResultChange,
        highlight,
        onFoldersMembershipChange,
        foldersMembership,
        mapboxStyle,
        onOverlaysChange,
        overlays,
    }: GetInteractionHandlersOptions<NormalMapInteraction>) => {
        if (interaction.subtype !== 'hovering') return;
        const {feature} = interaction;

        if (popup) {
            onPopupChange(undefined);
        } else {
            openPopup({
                feature,
                onPopupChange,
                waypointDispatcher,
                trackDispatcher,
                areaDispatcher,
                onSearchResultChange,
                highlight,
                onFoldersMembershipChange,
                foldersMembership,
                lngLat: feature.geometry.type === 'Point' ?
                    convertLngLat(feature.geometry.coordinates) :
                    event.lngLat,
                mapboxStyle,
                mapboxLayerId: feature.layer.id,
                onOverlaysChange,
                overlays,
            });
        }

    },

    onDblClick: () => {},
};
